import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { ResourceList } from '@pos-app/data';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { EventService } from '@pos-app/core-ui';
import { takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { getformatedTime, getformatedTimeHHMM, getformatedTimeHHMMForApi } from '../scheduler-helper';
import { ToastrService } from 'ngx-toastr';

export interface EditUser {
  currentData?: ResourceList;
  originalData: ResourceList;
  editable: boolean;
  validator: UntypedFormGroup;
  genericResourceTF: boolean;
}

@Component({
    selector: 'app-resource',
    styleUrls: ['./resource.component.css'],
    templateUrl: './resource.component.html',
    standalone: false
})
export class NgbdModalResourceContent implements OnInit {
  ELEMENT_DATA: EditUser[] = [];
  displayedColumns: string[] = ['action', 'resourceName', 'resourceDesc1', 'resourceDesc2', 'includeInBillableHoursTF', 'delete'];
  dataSource: MatTableDataSource<EditUser>;
  selected = 'option1';

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('focus', { static: false }) resourceDesc1: ElementRef;
  unSubscribe$ = new Subject<void>();
  @Input() actionAddResource;
  @Input() actionChangeResource;
  @Input() actionRemoveResource;
  @Input() resourceList;
  @Input() defaultBranch: string;
  @Input() currentDate: string;
  @Input() availableResources;
  @Input() globalData;
  selectedResource: string;
  selectedResourceID: number;
  selectedResource_add: string = 'SELECT RESOURCE TYPE';
  resource: any;
  selectedTimeFrameType: string;
  justToday: string = 'justToday';
  dateRange: string = 'dateRange';
  future: string = 'future';
  isSubmitted = false;
  resourceRemoveform: UntypedFormGroup;
  addResourceFrom: UntypedFormGroup;
  changeResourceFrom: UntypedFormGroup;
  changeDateTime: UntypedFormGroup;
  editResourceForm: any;
  overriddenHoursTF: boolean = false;
  showDateTimeFrame: boolean = false;
  timeframeEditable: boolean = false;
  showHoursForm: boolean = false;
  editResource: boolean = true;
  changeDateAndTime: boolean = false;
  showResourceSearchTable: boolean = false;
  edited: boolean = false;
  allowResourceTyping = false;
  filteredResources: any[];
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }
  overriddenHoursfinishTimeTF: boolean = false;
  overriddenBreakTF: boolean = false;
  disableBreak1: boolean = false;
  disableBreak2: boolean = false;
  disableBreak3: boolean = false;
  showIncludeInBillableHoursTF: boolean = false;

  constructor(public activeModal: NgbActiveModal, private fb: UntypedFormBuilder, private eventService: EventService, private toastr: ToastrService) {}

  ngOnInit() {
    if (this.actionAddResource) {
      let fromTime = [];
      let toTime = [];
      let break1StartTime = [];
      let break2StartTime = [];
      let break3StartTime = [];
      this.addResourceFrom = new UntypedFormGroup({
        resourceType: new UntypedFormControl('', Validators.required),
        resourceName: new UntypedFormControl('<Select type first>', Validators.required),
        resourceDesc1: new UntypedFormControl(''),
        resourceDesc2: new UntypedFormControl(''),
        includeInBillableHoursTF: new UntypedFormControl(false),
        timeframe: new UntypedFormControl('', Validators.required),
        hours: new UntypedFormControl('', Validators.required),
        startDate: new UntypedFormControl('', Validators.required),
        endDate: new UntypedFormControl('', Validators.required),
        startTime: new UntypedFormControl(''),
        finishTime: new UntypedFormControl(''),
        break1StartTime: new UntypedFormControl(''),
        break1EndTime: new UntypedFormControl(''),
        break1Name: new UntypedFormControl(''),
        break2StartTime: new UntypedFormControl(''),
        break2EndTime: new UntypedFormControl(''),
        break2Name: new UntypedFormControl(''),
        break3StartTime: new UntypedFormControl(''),
        break3EndTime: new UntypedFormControl(''),
        break3Name: new UntypedFormControl(''),
      });

      this.addResourceFrom.get('resourceType').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        if (val.resourceType) {
          this.allowResourceTyping = true;
          this.addResourceFrom.controls['resourceName'].setValue('');
        }
      });

      this.addResourceFrom.get('resourceName').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();

        if (val.resourceType === '1' && val.resourceName.length > 2) {
          this.showIncludeInBillableHoursTF = false;
          this.addResourceFrom.get('includeInBillableHoursTF').setValue(false);

          this.showResourceSearchTable = true;
          this.filteredResources = this.availableResources.filter(
            (el) => el?.name.toLowerCase().indexOf(val.resourceName) != -1 && el?.genericResourceTF === false
          );
        } else if (val.resourceType === '2' && val.resourceName.length > 2) {
          this.showIncludeInBillableHoursTF = false;
          this.addResourceFrom.get('includeInBillableHoursTF').setValue(false);

          this.showResourceSearchTable = true;
          this.filteredResources = this.availableResources.filter(
            (el) => el?.name.toLowerCase().indexOf(val.resourceName) != -1 && el?.genericResourceTF === true
          );
        } else if (val.resourceType === '4') {
          this.showResourceSearchTable = false;
          this.filteredResources = [];
          this.selectedResourceID = 0;
          this.showIncludeInBillableHoursTF = true;
        } else {
          this.showResourceSearchTable = false;
          this.filteredResources = [];
          this.selectedResourceID = 0;
          this.showIncludeInBillableHoursTF = false;
          this.addResourceFrom.get('includeInBillableHoursTF').setValue(false);
        }
      });
      this.addResourceFrom.get('timeframe').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        if (val.timeframe === 1) {
          this.showDateTimeFrame = true;
          this.timeframeEditable = false;

          this.addResourceFrom.patchValue({
            startDate: this.currentDate,
            endDate: this.currentDate,
          });
        }
        if (val.timeframe === 2) {
          this.timeframeEditable = false;
          this.showDateTimeFrame = true;
          this.addResourceFrom.patchValue({
            startDate: this.currentDate,
            endDate: '01/01/2040',
          });
        }
        if (val.timeframe === 3) {
          this.timeframeEditable = true;
          this.showDateTimeFrame = true;
          this.addResourceFrom.patchValue({
            startDate: '',
            endDate: '',
          });
          //TODO: Validate date or input from date picker
        }
      });
      this.addResourceFrom.get('hours').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        if (val.hours === 1) {
          this.addResourceFrom.get('startTime').setValidators(null);
          this.addResourceFrom.get('finishTime').setValidators(null);
          this.addResourceFrom.get('startTime').updateValueAndValidity();
          this.addResourceFrom.get('finishTime').updateValueAndValidity();
          this.showHoursForm = true;
          this.overriddenHoursTF = false;
          this.addResourceFrom.patchValue({
            startTime: getformatedTime(this.globalData?.startTime.toString()),
            finishTime: getformatedTime(this.globalData?.finishTime.toString()),
            break1StartTime: getformatedTime(this.globalData?.break1StartTime.toString()),
            break1EndTime: getformatedTime(this.globalData?.break1EndTime.toString()),
            break1Name: this.globalData?.break1Name,
            break2StartTime: getformatedTime(this.globalData?.break2StartTime.toString()),
            break2EndTime: getformatedTime(this.globalData?.break2EndTime.toString()),
            break2Name: this.globalData?.break2Name,
            break3StartTime: getformatedTime(this.globalData?.break3StartTime.toString()),
            break3EndTime: getformatedTime(this.globalData?.break3EndTime.toString()),
            break3Name: this.globalData?.break3Name,
          });
        }
        if (val.hours === 2) {
          this.addResourceFrom.get('startTime').setValidators(Validators.required);
          this.addResourceFrom.get('finishTime').setValidators(Validators.required);
          this.addResourceFrom.get('startTime').updateValueAndValidity();
          this.addResourceFrom.get('finishTime').updateValueAndValidity();
          this.showHoursForm = true;
          this.overriddenHoursTF = true;
        }
      });
      this.addResourceFrom.get('startTime').valueChanges.subscribe(() => {
        //
        const val = this.addResourceFrom.getRawValue();
        if (val?.startTime) {
          this.overriddenHoursfinishTimeTF = true;
        }
        if (val?.startTime && val?.finishTime) {
          fromTime = val?.startTime.split(':');
          toTime = val?.finishTime.split(':');
          if (
            parseInt(fromTime[0]) > parseInt(toTime[0]) ||
            (parseInt(fromTime[0]) === parseInt(toTime[0]) && parseInt(fromTime[1]) > parseInt(toTime[1]))
          ) {
            this.toastr.error('Start time cannot be after Finish time');
            this.addResourceFrom.patchValue({
              startTime: '',
            });
          } else if (val?.break1StartTime || val?.break2StartTime || val?.break3StartTime) {
            break1StartTime = val?.break1StartTime && val?.break1StartTime?.split(':');
            break2StartTime = val?.break2StartTime && val?.break2StartTime?.split(':');
            break3StartTime = val?.break3StartTime && val?.break3StartTime?.split(':');
            if (fromTime[0] > break1StartTime[0] || fromTime[0] > break2StartTime[0] || fromTime[0] > break3StartTime[0]) {
              this.toastr.error('Start time cannot be smaller than break start time');
              this.addResourceFrom.patchValue({
                startTime: '',
              });
            }
            if (
              (parseInt(fromTime[0]) === parseInt(break1StartTime[0]) && parseInt(fromTime[1]) > parseInt(break1StartTime[1])) ||
              (parseInt(fromTime[0]) === parseInt(break2StartTime[0]) && parseInt(fromTime[1]) > parseInt(break2StartTime[1])) ||
              (parseInt(fromTime[0]) === parseInt(break3StartTime[0]) && parseInt(fromTime[1]) > parseInt(break3StartTime[1]))
            ) {
              this.toastr.error('Start time cannot be smaller than current break start time');
              this.addResourceFrom.patchValue({
                startTime: '',
              });
            }
          }
        }
      });
      this.addResourceFrom.get('finishTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        if (val?.startTime && val?.finishTime) {
          fromTime = val?.startTime.split(':');
          toTime = val?.finishTime.split(':');
          if (
            parseInt(fromTime[0]) > parseInt(toTime[0]) ||
            (parseInt(fromTime[0]) === parseInt(toTime[0]) && parseInt(fromTime[1]) > parseInt(toTime[1]))
          ) {
            this.toastr.error('Finish time cannot be before Start time');
            this.addResourceFrom.patchValue({
              finishTime: '',
            });
            this.overriddenBreakTF = false;
          } else if (val?.break1EndTime || val?.break2EndTime || val?.break3EndTime) {
            let break1EndTime = val?.break1EndTime && val?.break1EndTime?.split(':');
            let break2EndTime = val?.break2EndTime && val?.break2EndTime?.split(':');
            let break3EndTime = val?.break3EndTime && val?.break3EndTime?.split(':');
            if (toTime[0] < break1EndTime[0] || toTime[0] < break2EndTime[0] || toTime[0] < break3EndTime[0]) {
              this.toastr.error('End time cannot be smaller than  current break end time');
              this.addResourceFrom.patchValue({
                finishTime: '',
              });
              this.overriddenBreakTF = false;
            }
            if (
              (parseInt(toTime[0]) === parseInt(break1EndTime[0]) && parseInt(toTime[1]) < parseInt(break1EndTime[1])) ||
              (parseInt(toTime[0]) === parseInt(break2EndTime[0]) && parseInt(toTime[1]) < parseInt(break2EndTime[1])) ||
              (parseInt(toTime[0]) === parseInt(break3EndTime[0]) && parseInt(toTime[1]) < parseInt(break3EndTime[1]))
            ) {
              this.toastr.error('Start time cannot be smaller than  current break start time');
              this.addResourceFrom.patchValue({
                finishTime: '',
              });
              this.overriddenBreakTF = false;
            }
          } else {
            this.overriddenBreakTF = true;
          }
        }
      });

      this.addResourceFrom.get('break1StartTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();

        const error = val?.break1StartTime && this.breakStartValidation(val?.break1StartTime, fromTime, toTime, val, 1);
        if (error) {
          this.toastr.error(error);
          this.addResourceFrom.patchValue({
            break1StartTime: '',
          });
          this.addResourceFrom.get('break1StartTime').setValidators(Validators.required);
          this.addResourceFrom.get('break1StartTime').updateValueAndValidity();
        } else if (val?.break1StartTime && !val?.break1EndTime) {
          this.addResourceFrom.get('break1EndTime').setValidators(Validators.required);
          this.addResourceFrom.get('break1EndTime').updateValueAndValidity();
        }
      });
      this.addResourceFrom.get('break1EndTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        const error = val?.break1EndTime && this.breakEndValidation(val?.break1EndTime, val?.break1StartTime, toTime, val, 1);
        if (error) {
          this.toastr.error(error);
          this.addResourceFrom.patchValue({
            break1EndTime: '',
          });
          this.addResourceFrom.get('break1EndTime').setValidators(Validators.required);
          this.addResourceFrom.get('break1EndTime').updateValueAndValidity();
        } else if (val?.break1EndTime && !val?.break1StartTime) {
          this.addResourceFrom.get('break1StartTime').setValidators(Validators.required);
          this.addResourceFrom.get('break1StartTime').updateValueAndValidity();
        }
      });
      //break 2 validation

      this.addResourceFrom.get('break2StartTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();

        const error = val?.break2StartTime && this.breakStartValidation(val?.break2StartTime, fromTime, toTime, val, 2);
        if (error) {
          this.toastr.error(error);
          this.addResourceFrom.patchValue({
            break2StartTime: '',
          });
          this.addResourceFrom.get('break2StartTime').setValidators(Validators.required);
          this.addResourceFrom.get('break2StartTime').updateValueAndValidity();
        } else if (val?.break2StartTime && !val?.break2EndTime) {
          this.addResourceFrom.get('break2EndTime').setValidators(Validators.required);
          this.addResourceFrom.get('break2EndTime').updateValueAndValidity();
        }
      });
      this.addResourceFrom.get('break2EndTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        const error = val?.break2EndTime && this.breakEndValidation(val?.break2EndTime, val?.break2StartTime, toTime, val, 2);
        if (error) {
          this.toastr.error(error);
          this.addResourceFrom.patchValue({
            break2EndTime: '',
          });
          this.addResourceFrom.get('break2EndTime').setValidators(Validators.required);
          this.addResourceFrom.get('break2EndTime').updateValueAndValidity();
        } else if (val?.break2EndTime && !val?.break2StartTime) {
          this.addResourceFrom.get('break2StartTime').setValidators(Validators.required);
          this.addResourceFrom.get('break2StartTime').updateValueAndValidity();
        }
      });

      this.addResourceFrom.get('break3StartTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();

        const error = val?.break3StartTime && this.breakStartValidation(val?.break3StartTime, fromTime, toTime, val, 3);
        if (error) {
          this.toastr.error(error);
          this.addResourceFrom.patchValue({
            break3StartTime: '',
          });
          this.addResourceFrom.get('break3StartTime').setValidators(Validators.required);
          this.addResourceFrom.get('break3StartTime').updateValueAndValidity();
        } else if (val?.break3StartTime && !val?.break3EndTime) {
          this.addResourceFrom.get('break3EndTime').setValidators(Validators.required);
          this.addResourceFrom.get('break3EndTime').updateValueAndValidity();
        }
      });
      this.addResourceFrom.get('break3EndTime').valueChanges.subscribe(() => {
        const val = this.addResourceFrom.getRawValue();
        const error = val?.break3EndTime && this.breakEndValidation(val?.break3EndTime, val?.break3StartTime, toTime, val, 3);
        if (error) {
          this.toastr.error(error);
          this.addResourceFrom.patchValue({
            break3EndTime: '',
          });
          this.addResourceFrom.get('break3EndTime').setValidators(Validators.required);
          this.addResourceFrom.get('break3EndTime').updateValueAndValidity();
        } else if (val?.break3EndTime && !val?.break3StartTime) {
          this.addResourceFrom.get('break3StartTime').setValidators(Validators.required);
          this.addResourceFrom.get('break3StartTime').updateValueAndValidity();
        }
      });
    }
    if (this.actionChangeResource) {
      let fromTime = [];
      let toTime = [];
      let break1StartTime = [];
      let break2StartTime = [];
      let break3StartTime = [];
      let break1EndTime = [];
      let break2EndTime = [];
      let break3EndTime = [];

      this.editResourceForm = (e) =>
        new UntypedFormGroup({
          resourceName: new UntypedFormControl(e.resourceName, Validators.required),
          resourceDesc1: new UntypedFormControl(e.resourceDesc1, Validators.required),
          resourceDesc2: new UntypedFormControl(e.resourceDesc2, Validators.required),
          includeInBillableHoursTF: new UntypedFormControl(e.includeInBillableHoursTF, Validators.required),
        });
      this.resourceList.forEach((element) => {
        this.ELEMENT_DATA.push({
          currentData: element,
          originalData: element,
          editable: false,
          validator: this.editResourceForm(element),
          genericResourceTF: element?.genericResourceTF,
        });
      });
      this.dataSource = new MatTableDataSource(this.ELEMENT_DATA.slice());
      this.dataSource.sort = this.sort;
      this.changeDateTime = new UntypedFormGroup({
        timeframe: new UntypedFormControl('', Validators.required),
        hours: new UntypedFormControl('', Validators.required),
        startDate: new UntypedFormControl('', Validators.required),
        endDate: new UntypedFormControl('', Validators.required),
        startTime: new UntypedFormControl(''),
        finishTime: new UntypedFormControl(''),
        break1StartTime: new UntypedFormControl(''),
        break1EndTime: new UntypedFormControl(''),
        break1Name: new UntypedFormControl(''),
        break2StartTime: new UntypedFormControl(''),
        break2EndTime: new UntypedFormControl(''),
        break2Name: new UntypedFormControl(''),
        break3StartTime: new UntypedFormControl(''),
        break3EndTime: new UntypedFormControl(''),
        break3Name: new UntypedFormControl(''),
      });
      this.changeDateTime.get('timeframe').valueChanges.subscribe(() => {
        const val = this.changeDateTime.getRawValue();
        if (val.timeframe === 1) {
          this.timeframeEditable = false;
          this.showDateTimeFrame = true;
          this.changeDateTime.patchValue({
            startDate: this.currentDate,
            endDate: this.currentDate,
          });
        }
        if (val.timeframe === 2) {
          this.showDateTimeFrame = true;
          this.timeframeEditable = false;
          this.changeDateTime.patchValue({
            startDate: this.currentDate,
            endDate: '01/01/2040',
          });
        }
        if (val.timeframe === 3) {
          this.showDateTimeFrame = true;
          this.timeframeEditable = true;
          this.changeDateTime.patchValue({
            startDate: '',
            endDate: '',
          });
          //TODO: Validate date or input from date picker
        }
      });
      this.changeDateTime.get('hours').valueChanges.subscribe(() => {
        const val = this.changeDateTime.getRawValue();
        if (val.hours === 1) {
          this.changeDateTime.get('startTime').setValidators(null);
          this.changeDateTime.get('finishTime').setValidators(null);
          this.changeDateTime.get('startTime').updateValueAndValidity();
          this.changeDateTime.get('finishTime').updateValueAndValidity();
          this.showHoursForm = true;
          this.overriddenHoursTF = false;
          this.changeDateTime.patchValue({
            startTime: getformatedTime(this.globalData?.startTime.toString()),
            finishTime: getformatedTime(this.globalData?.finishTime.toString()),
            break1StartTime: getformatedTime(this.globalData?.break1StartTime.toString()),
            break1EndTime: getformatedTime(this.globalData?.break1EndTime.toString()),
            break1Name: this.globalData?.break1Name,
            break2StartTime: getformatedTime(this.globalData?.break2StartTime.toString()),
            break2EndTime: getformatedTime(this.globalData?.break2EndTime.toString()),
            break2Name: this.globalData?.break2Name,
            break3StartTime: getformatedTime(this.globalData?.break3StartTime.toString()),
            break3EndTime: getformatedTime(this.globalData?.break3EndTime.toString()),
            break3Name: this.globalData?.break3Name,
          });
        }
        if (val.hours === 2) {
          this.showHoursForm = true;
          this.overriddenHoursTF = true;
          if (val?.startTime && val?.finishTime) {
            this.overriddenHoursfinishTimeTF = true;
            this.disableBreak1 = false;
            this.disableBreak2 = false;
            this.disableBreak3 = false;
            this.overriddenBreakTF = true;
          } else {
            this.overriddenHoursfinishTimeTF = false;
          }
          this.changeDateTime.get('startTime').setValidators(Validators.required);
          this.changeDateTime.get('finishTime').setValidators(Validators.required);
          this.changeDateTime.get('startTime').updateValueAndValidity();
          this.changeDateTime.get('finishTime').updateValueAndValidity();
        }
        this.changeDateTime.get('startTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();
          if (val?.startTime) {
            this.overriddenHoursfinishTimeTF = true;
          }
          if (val?.startTime && val?.finishTime) {
            fromTime = val?.startTime.split(':');
            toTime = val?.finishTime.split(':');
            if (
              parseInt(fromTime[0]) > parseInt(toTime[0]) ||
              (parseInt(fromTime[0]) === parseInt(toTime[0]) && parseInt(fromTime[1]) > parseInt(toTime[1]))
            ) {
              this.toastr.error('Start time cannot be after finish time');
              this.addResourceFrom.patchValue({
                startTime: '',
              });
            } else if (val?.break1StartTime || val?.break2StartTime || val?.break3StartTime) {
              break1StartTime = val?.break1StartTime && val?.break1StartTime?.split(':');
              break2StartTime = val?.break2StartTime && val?.break2StartTime?.split(':');
              break3StartTime = val?.break3StartTime && val?.break3StartTime?.split(':');
              if (fromTime[0] > break1StartTime[0] || fromTime[0] > break2StartTime[0] || fromTime[0] > break3StartTime[0]) {
                this.toastr.error('Start time cannot be smaller than break start time');
                this.changeDateTime.patchValue({
                  startTime: '',
                });
              }
              if (
                (parseInt(fromTime[0]) === parseInt(break1StartTime[0]) && parseInt(fromTime[1]) > parseInt(break1StartTime[1])) ||
                (parseInt(fromTime[0]) === parseInt(break2StartTime[0]) && parseInt(fromTime[1]) > parseInt(break2StartTime[1])) ||
                (parseInt(fromTime[0]) === parseInt(break3StartTime[0]) && parseInt(fromTime[1]) > parseInt(break3StartTime[1]))
              ) {
                this.toastr.error('Start time cannot be smaller than current break start time');
                this.changeDateTime.patchValue({
                  startTime: '',
                });
              }
            }
          }
        });
        this.changeDateTime.get('finishTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();
          if (val?.startTime && val?.finishTime) {
            this.overriddenHoursfinishTimeTF = true;
            this.overriddenBreakTF = true;
            fromTime = val?.startTime.split(':');
            toTime = val?.finishTime.split(':');
            if (
              parseInt(fromTime[0]) > parseInt(toTime[0]) ||
              (parseInt(fromTime[0]) === parseInt(toTime[0]) && parseInt(fromTime[1]) > parseInt(toTime[1]))
            ) {
              this.toastr.error('Finish time cannot be before start time');
              this.changeDateTime.patchValue({
                finishTime: '',
              });
              this.overriddenBreakTF = false;
            } else if (val?.break1EndTime || val?.break2EndTime || val?.break3EndTime) {
              break1EndTime = val?.break1EndTime ? val?.break1EndTime?.split(':') : '';
              break2EndTime = val?.break2EndTime ? val?.break2EndTime?.split(':') : '';
              break3EndTime = val?.break3EndTime ? val?.break3EndTime?.split(':') : '';
              if (toTime[0] < break1EndTime[0] || toTime[0] < break2EndTime[0] || toTime[0] < break3EndTime[0]) {
                this.toastr.error('End time cannot be smaller than current break end time');
                this.changeDateTime.patchValue({
                  finishTime: '',
                });
                this.overriddenBreakTF = false;
              }
              if (
                (parseInt(toTime[0]) === parseInt(break1EndTime[0]) && parseInt(toTime[1]) < parseInt(break1EndTime[1])) ||
                (parseInt(toTime[0]) === parseInt(break2EndTime[0]) && parseInt(toTime[1]) < parseInt(break2EndTime[1])) ||
                (parseInt(toTime[0]) === parseInt(break3EndTime[0]) && parseInt(toTime[1]) < parseInt(break3EndTime[1]))
              ) {
                this.toastr.error('Start time cannot be smaller than current break end time');
                this.changeDateTime.patchValue({
                  finishTime: '',
                });
                this.overriddenBreakTF = false;
              }
            } else {
              this.overriddenBreakTF = true;
            }
          }
        });

        this.changeDateTime.get('break1StartTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();

          const error = val?.changeDateTime && this.breakStartValidation(val?.break1StartTime, fromTime, toTime, val, 1);
          if (error) {
            this.toastr.error(error);
            this.changeDateTime.patchValue({
              break1StartTime: '',
            });
            this.changeDateTime.get('break1StartTime').setValidators(Validators.required);
            this.changeDateTime.get('break1StartTime').updateValueAndValidity();
          } else if (val?.break1StartTime && !val?.break1EndTime) {
            this.changeDateTime.get('break1EndTime').setValidators(Validators.required);
            this.changeDateTime.get('break1EndTime').updateValueAndValidity();
          }
        });
        this.changeDateTime.get('break1EndTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();
          const error = val?.break1EndTime && this.breakEndValidation(val?.break1EndTime, val?.break1StartTime, toTime, val, 1);
          if (error) {
            this.toastr.error(error);
            this.changeDateTime.patchValue({
              break1EndTime: '',
            });
            this.changeDateTime.get('break1EndTime').setValidators(Validators.required);
            this.changeDateTime.get('break1EndTime').updateValueAndValidity();
          } else if (val?.break1EndTime && !val?.break1StartTime) {
            this.changeDateTime.get('break1StartTime').setValidators(Validators.required);
            this.changeDateTime.get('break1StartTime').updateValueAndValidity();
          }
        });
        //break 2 validation

        this.changeDateTime.get('break2StartTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();

          const error = val?.changeDateTime && this.breakStartValidation(val?.break2StartTime, fromTime, toTime, val, 2);
          if (error) {
            this.toastr.error(error);
            this.changeDateTime.patchValue({
              break1StartTime: '',
            });
            this.changeDateTime.get('break2StartTime').setValidators(Validators.required);
            this.changeDateTime.get('break2StartTime').updateValueAndValidity();
          } else if (val?.break2StartTime && !val?.break2EndTime) {
            this.changeDateTime.get('break2EndTime').setValidators(Validators.required);
            this.changeDateTime.get('break2EndTime').updateValueAndValidity();
          }
        });
        this.changeDateTime.get('break2EndTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();
          const error = val?.break2EndTime && this.breakEndValidation(val?.break2EndTime, val?.break2StartTime, toTime, val, 2);
          if (error) {
            this.toastr.error(error);
            this.changeDateTime.patchValue({
              break2EndTime: '',
            });
            this.changeDateTime.get('break2EndTime').setValidators(Validators.required);
            this.changeDateTime.get('break2EndTime').updateValueAndValidity();
          } else if (val?.break2EndTime && !val?.break2StartTime) {
            this.changeDateTime.get('break2StartTime').setValidators(Validators.required);
            this.changeDateTime.get('break2StartTime').updateValueAndValidity();
          }
        });

        this.changeDateTime.get('break3StartTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();

          const error = val?.break3StartTime && this.breakStartValidation(val?.break3StartTime, fromTime, toTime, val, 3);
          if (error) {
            this.toastr.error(error);
            this.changeDateTime.patchValue({
              break3StartTime: '',
            });
            this.changeDateTime.get('break3StartTime').setValidators(Validators.required);
            this.changeDateTime.get('break3StartTime').updateValueAndValidity();
          } else if (val?.break3StartTime && !val?.break3EndTime) {
            this.changeDateTime.get('break3EndTime').setValidators(Validators.required);
            this.changeDateTime.get('break3EndTime').updateValueAndValidity();
          }
        });
        this.changeDateTime.get('break3EndTime').valueChanges.subscribe(() => {
          const val = this.changeDateTime.getRawValue();
          const error = val?.break3EndTime && this.breakEndValidation(val?.break3EndTime, val?.break3StartTime, toTime, val, 3);
          if (error) {
            this.toastr.error(error);
            this.changeDateTime.patchValue({
              break3EndTime: '',
            });
            this.changeDateTime.get('break3EndTime').setValidators(Validators.required);
            this.changeDateTime.get('break3EndTime').updateValueAndValidity();
          } else if (val?.break3EndTime && !val?.break3StartTime) {
            this.changeDateTime.get('break3StartTime').setValidators(Validators.required);
            this.changeDateTime.get('break3StartTime').updateValueAndValidity();
          }
        });
      });
    }
    if (this.actionRemoveResource) {
      this.resourceRemoveform = new UntypedFormGroup({
        resourceID: new UntypedFormControl('<Select type first>', Validators.required),
        timeframe: new UntypedFormControl('', Validators.required),
        startDate: new UntypedFormControl('', Validators.required),
        endDate: new UntypedFormControl('', Validators.required),
      });

      this.resourceRemoveform.get('timeframe').valueChanges.subscribe(() => {
        const val = this.resourceRemoveform.getRawValue();
        if (val.timeframe === 1) {
          this.showDateTimeFrame = true;
          this.timeframeEditable = false;

          this.resourceRemoveform.patchValue({
            startDate: this.currentDate,
            endDate: this.currentDate,
          });
        }
        if (val.timeframe === 2) {
          this.timeframeEditable = false;
          this.showDateTimeFrame = true;
          this.resourceRemoveform.patchValue({
            startDate: this.currentDate,
            endDate: '01/01/2040',
          });
        }
        if (val.timeframe === 3) {
          this.timeframeEditable = true;
          this.showDateTimeFrame = true;
          this.resourceRemoveform.patchValue({
            startDate: '',
            endDate: '',
          });
        }
      });
    }
  }

  submitForm(edited) {
    if (edited) {
      //call api with value(this.resourceRemoveform.value);
      this.changeDateAndTime = false;
    } else {
      this.changeDateAndTime = edited;
    }
  }
  submitChangeDateTimeForm(edited) {
    this.loading = true;
    if (edited) {
      delete this.changeDateTime.value.timeframe;
      delete this.changeDateTime.value.hours;
      delete this.changeDateTime.value.resourceName;
      let dataToUpdateResource = this.changeDateTime.value;
      Object.assign(dataToUpdateResource, { resourceID: this.selectedResourceID });
      Object.assign(dataToUpdateResource, { branch: this.defaultBranch });
      this.changeDateTime.value['startTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.startTime);
      this.changeDateTime.value['finishTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.finishTime);
      this.changeDateTime.value['break1StartTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.break1StartTime);
      this.changeDateTime.value['break1EndTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.break1EndTime);
      this.changeDateTime.value['break2StartTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.break2StartTime);
      this.changeDateTime.value['break2EndTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.break2EndTime);
      this.changeDateTime.value['break3StartTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.break3StartTime);
      this.changeDateTime.value['break3EndTime'] = getformatedTimeHHMMForApi(this.changeDateTime.value.break3EndTime);
      this.editResource = true;
      this.eventService
        .changeResourceSchedule(dataToUpdateResource)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data?.ErrorFlag === '0') {
            return this.activeModal.close('updated');
          }
        });
    } else {
      this.changeDateAndTime = edited;
      this.editResource = true;
    }
    this.loading = false;
  }
  submitAddResourceFrom(submit) {
    this.loading = true;
    if (submit && this.actionAddResource) {
      delete this.addResourceFrom.value?.timeframe;
      delete this.addResourceFrom.value?.hours;
      delete this.addResourceFrom.value.resourceType;
      let dataToUpdateResource = this.addResourceFrom.value;
      Object.assign(dataToUpdateResource, { resourceID: this.selectedResourceID });
      Object.assign(dataToUpdateResource, { branch: this.defaultBranch });
      this.addResourceFrom.value['startTime'] = this.overriddenHoursTF ? getformatedTimeHHMMForApi(this.addResourceFrom.value.startTime) : 0;
      this.addResourceFrom.value['finishTime'] = this.overriddenHoursTF ? getformatedTimeHHMMForApi(this.addResourceFrom.value.finishTime) : 0;
      this.addResourceFrom.value['break1StartTime'] = this.overriddenHoursTF
        ? getformatedTimeHHMMForApi(this.addResourceFrom.value.break1StartTime)
        : 0;
      this.addResourceFrom.value['break1EndTime'] = this.overriddenHoursTF ? getformatedTimeHHMMForApi(this.addResourceFrom.value.break1EndTime) : 0;
      this.addResourceFrom.value['break2StartTime'] = this.overriddenHoursTF
        ? getformatedTimeHHMMForApi(this.addResourceFrom.value.break2StartTime)
        : 0;
      this.addResourceFrom.value['break2EndTime'] = this.overriddenHoursTF ? getformatedTimeHHMMForApi(this.addResourceFrom.value.break2EndTime) : 0;
      this.addResourceFrom.value['break3StartTime'] = this.overriddenHoursTF
        ? getformatedTimeHHMMForApi(this.addResourceFrom.value.break3StartTime)
        : 0;
      this.addResourceFrom.value['break3EndTime'] = this.overriddenHoursTF ? getformatedTimeHHMMForApi(this.addResourceFrom.value.break3EndTime) : 0;
      this.eventService
        .addResourceToSchedule(dataToUpdateResource)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data?.ErrorFlag === '0') {
            this.activeModal.close(true);
          }
        });
    } else {
      this.actionAddResource = false;
      this.activeModal.close();
    }
    this.loading = false;
  }
  submitResourceRemoveform(submit) {
    this.loading = true;
    if (submit && this.actionRemoveResource) {
      delete this.resourceRemoveform.value.timeframe;
      this.resourceRemoveform.value['resourceID'] = Number(this.resourceRemoveform.value.resourceID);
      let dataToRemoveResource = this.resourceRemoveform.value;
      Object.assign(dataToRemoveResource, { branch: this.defaultBranch });
      Object.assign(dataToRemoveResource, { confirmedTF: false });
      this.eventService
        .removeResourceFromSchedule(dataToRemoveResource)
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((data) => {
          if (data?.confirmationRequiredTF) {
            this.activeModal.close({ confirmationRequired: true, dataToRemoveResource, message: data?.Message });
          } else {
            this.actionAddResource = false;
            this.activeModal.close(true);
          }
        });
    } else {
      this.actionRemoveResource = false;
      this.activeModal.close(false);
    }
    this.loading = false;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteRow(index: number) {
    const data = this.dataSource.data;
    data.splice(index, 1);

    this.dataSource.data = data;
  }
  confirmEditCreate(row) {
    this.edited = true;
    row.editable = false;
    Object.keys(row.validator.controls).forEach((item) => {
      row.currentData[item] = row.validator.controls[item].value;
    });
  }

  startEdit(row, i) {
    row.editable = true;
    this.edited = false;
    Object.keys(row.validator.controls).forEach((item) => {
      row.currentData[item] = row.validator.controls[item].value;
    });
    this.selectedResource = row.currentData.resourceName;
    this.selectedResourceID = row.currentData.resourceID;
    //TODO:  make autofocus key on description resource1
  }

  cancelOrDelete(row, i) {
    if (row.editable) {
      row.editable = false;
      Object.keys(row.validator.controls).forEach((item) => {
        row.validator.controls[item].patchValue(row.currentData[item]);
      });
    } else {
    }
  }
  changeTimeDate(row, i) {
    row.editable = true;
    this.edited = false;
    Object.keys(row.validator.controls).forEach((item) => {
      row.currentData[item] = row.validator.controls[item].value;
    });
    this.selectedResource = row.currentData.resourceName;
    this.selectedResourceID = row.currentData.resourceID;
    this.eventService
      .fetchResourceHours({
        resourceID: this.selectedResourceID,
        branch: this.defaultBranch,
        date: this.currentDate,
      })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          this.changeDateAndTime = true;
          this.editResource = false;
          this.overriddenHoursTF = data?.resource?.overriddenHoursTF;
          this.changeDateTime.patchValue({
            startTime: getformatedTimeHHMM(data?.resource?.startTime.toString()),
            finishTime: getformatedTimeHHMM(data?.resource?.finishTime.toString()),
            break1StartTime: getformatedTimeHHMM(data?.resource?.break1StartTime.toString()),
            break1EndTime: getformatedTimeHHMM(data?.resource?.break1EndTime.toString()),
            break1Name: data?.resource?.break1Name,
            break2StartTime: getformatedTimeHHMM(data?.resource?.break2StartTime.toString()),
            break2EndTime: getformatedTimeHHMM(data?.resource?.break2EndTime.toString()),
            break2Name: data?.resource?.break2Name,
            break3StartTime: getformatedTimeHHMM(data?.resource?.break3StartTime.toString()),
            break3EndTime: getformatedTimeHHMM(data?.resource?.break3EndTime.toString()),
            break3Name: data?.resource?.break3Name,
          });
        }
      });
  }
  changeFn(e, row) {
    Object.keys(row.validator.controls).forEach((item) => {
      row.currentData[item] = row.validator.controls[item].value;
    });
  }
  saveAllChanges() {
    const newResources = this.dataSource.data.map((el) => {
      return {
        resourceID: el?.currentData?.resourceID,
        resourceDesc1: el?.currentData?.resourceDesc1,
        resourceDesc2: el?.currentData?.resourceDesc2,
        includeInBillableHoursTF: el?.currentData?.includeInBillableHoursTF,
      };
    });
    this.eventService
      .changeResourceDescription({ resourceArray: newResources })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        if (data?.ErrorFlag === '0') {
          this.activeModal.close(true);
        }
      });
  }
  selectResource(resource) {
    this.selectedResourceID = resource.resourceID;
    this.selectedResource = resource.resourceName;
    this.addResourceFrom.controls['resourceName'].setValue(resource.name);
    this.addResourceFrom.controls['resourceDesc1'].setValue(resource.resourceDesc1);
    this.addResourceFrom.controls['resourceDesc2'].setValue(resource.resourceDesc2);
    this.addResourceFrom.controls['includeInBillableHoursTF'].setValue(resource.includeInBillableHoursTF);
  }
  isFocus(e) {
    this.showResourceSearchTable = true;
    e.target.select();
  }

  lostFocus(e) {
    setTimeout(() => {
      this.showResourceSearchTable = false;
    }, 300);
  }
  updateSelecedID(id) {
    this.selectedResourceID = id;
  }
  breakStartValidation(breakStartTimeValue, fromTime, toTime, formValue, position) {
    const current = 'break' + position + 'EndTime';
    const currentStart = 'break' + position + 'StartTime';
    const currentValue = formValue[current].split(':');
    let error = '';
    if (fromTime && toTime && breakStartTimeValue) {
      let breakStartTime = breakStartTimeValue.split(':');
      if (
        parseInt(fromTime[0]) > parseInt(breakStartTime[0]) ||
        (parseInt(fromTime[0]) === parseInt(breakStartTime[0]) && parseInt(fromTime[1]) > parseInt(breakStartTime[1]))
      ) {
        error = 'Break time cannot be before start Ttime';
      } else if (
        parseInt(toTime[0]) < parseInt(breakStartTime[0]) ||
        (parseInt(toTime[0]) === parseInt(breakStartTime[0]) && parseInt(toTime[1]) < parseInt(breakStartTime[1]))
      ) {
        error = 'Break time cannot be after finish fime';
      } else if (this.checkBreakOverlap(breakStartTimeValue, formValue, position)) {
        error = 'Break Ttime overLap';
      } else if (
        (formValue[current] !== '' && parseInt(currentValue[0]) < parseInt(breakStartTime[0])) ||
        (formValue[current] !== '' &&
          parseInt(currentValue[0]) === parseInt(breakStartTime[0]) &&
          parseInt(currentValue[1]) < parseInt(breakStartTime[1]))
      ) {
        error = 'Break Ttime cannot be after break finish time';
      }
      if (formValue[current] === '' || error) {
        if (formValue[current] === '' && formValue[currentStart] === '') {
          this.disableBreak1 = false;
          this.disableBreak2 = false;
          this.disableBreak3 = false;
        } else if (position === 1) {
          this.disableBreak1 = false;
          this.disableBreak2 = true;
          this.disableBreak3 = true;
        } else if (position === 2) {
          this.disableBreak1 = true;
          this.disableBreak2 = false;
          this.disableBreak3 = true;
        } else {
          this.disableBreak1 = true;
          this.disableBreak2 = true;
          this.disableBreak3 = false;
        }
      } else {
        this.disableBreak1 = false;
        this.disableBreak2 = false;
        this.disableBreak3 = false;
      }
      return error;
    }
  }
  breakEndValidation(breakEndTimeValue, fromTime, toTime, formValue, position) {
    const current = 'break' + position + 'StartTime';
    const currentEnd = 'break' + position + 'EndTime';
    let error = '';
    if (fromTime && breakEndTimeValue) {
      let breakEndTime = breakEndTimeValue.split(':');
      fromTime = fromTime.split(':');
      if (
        parseInt(fromTime[0]) > parseInt(breakEndTime[0]) ||
        (parseInt(fromTime[0]) === parseInt(breakEndTime[0]) && parseInt(fromTime[1]) > parseInt(breakEndTime[1]))
      ) {
        error = 'Break 1 End time cannot be before Break 1 Start time';
      } else if (
        parseInt(toTime[0]) < parseInt(breakEndTime[0]) ||
        (parseInt(toTime[0]) === parseInt(breakEndTime[0]) && parseInt(toTime[1]) < parseInt(breakEndTime[1]))
      ) {
        error = 'Break 1 time cannot be after Finish time';
      } else if (this.checkBreakOverlap(breakEndTimeValue, formValue, position)) {
        error = 'Break time overLap';
      }
    }
    if (formValue[current] === '' || error) {
      if (formValue[current] === '' && formValue[currentEnd] === '') {
        this.disableBreak1 = false;
        this.disableBreak2 = false;
        this.disableBreak3 = false;
      } else if (position === 1) {
        this.disableBreak1 = false;
        this.disableBreak2 = true;
        this.disableBreak3 = true;
      } else if (position === 2) {
        this.disableBreak1 = true;
        this.disableBreak2 = false;
        this.disableBreak3 = true;
      } else {
        this.disableBreak1 = true;
        this.disableBreak2 = true;
        this.disableBreak3 = false;
      }
    } else {
      this.disableBreak1 = false;
      this.disableBreak2 = false;
      this.disableBreak3 = false;
    }
    return error;
  }
  clearBreakValue(value) {
    this.disableBreak1 = false;
    this.disableBreak2 = false;
    this.disableBreak3 = false;
    switch (value) {
      case 1:
        this?.addResourceFrom?.patchValue({
          break1StartTime: '',
          break1EndTime: '',
          break1Name: '',
        });
        this?.changeDateTime?.patchValue({
          break1StartTime: '',
          break1EndTime: '',
          break1Name: '',
        });
        this?.addResourceFrom?.get('break1StartTime').setValidators(null);
        this?.addResourceFrom?.get('break1StartTime').updateValueAndValidity();
        this?.addResourceFrom?.get('break1EndTime').setValidators(null);
        this?.addResourceFrom?.get('break1EndTime').updateValueAndValidity();
        this?.changeDateTime?.get('break1StartTime').setValidators(null);
        this?.changeDateTime?.get('break1StartTime').updateValueAndValidity();
        this?.changeDateTime?.get('break1EndTime').setValidators(null);
        this?.changeDateTime?.get('break1EndTime').updateValueAndValidity();
        break;
      case 2:
        this?.addResourceFrom?.patchValue({
          break2StartTime: '',
          break2EndTime: '',
          break2Name: '',
        });
        this?.changeDateTime?.patchValue({
          break2StartTime: '',
          break2EndTime: '',
          break2Name: '',
        });
        this?.addResourceFrom?.get('break2StartTime').setValidators(null);
        this?.addResourceFrom?.get('break2StartTime').updateValueAndValidity();
        this?.addResourceFrom?.get('break2EndTime').setValidators(null);
        this?.addResourceFrom?.get('break2EndTime').updateValueAndValidity();
        this?.changeDateTime?.get('break2StartTime').setValidators(null);
        this?.changeDateTime?.get('break2StartTime').updateValueAndValidity();
        this?.changeDateTime?.get('break2EndTime').setValidators(null);
        this?.changeDateTime?.get('break2EndTime').updateValueAndValidity();
        break;
      case 3:
        this?.addResourceFrom?.patchValue({
          break3StartTime: '',
          break3EndTime: '',
          break3Name: '',
        });
        this?.changeDateTime?.patchValue({
          break3StartTime: '',
          break3EndTime: '',
          break3Name: '',
        });
        this?.addResourceFrom?.get('break3StartTime').setValidators(null);
        this?.addResourceFrom?.get('break3StartTime').updateValueAndValidity();
        this?.addResourceFrom?.get('break3EndTime').setValidators(null);
        this?.addResourceFrom?.get('break3EndTime').updateValueAndValidity();
        this?.changeDateTime?.get('break3StartTime').setValidators(null);
        this?.changeDateTime?.get('break3StartTime').updateValueAndValidity();
        this?.changeDateTime?.get('break3EndTime').setValidators(null);
        this?.changeDateTime?.get('break3EndTime').updateValueAndValidity();
      default:
        return;
    }
  }
  checkBreakOverlap(time, formValue, position) {
    const targetDateTime = new Date(`2000-01-01 ${time}`);
    const break1StartDateTime = new Date(`2000-01-01 ${formValue.break1StartTime}`);
    const break1EndDateTime = new Date(`2000-01-01 ${formValue.break1EndTime}`);
    const break2StartDateTime = new Date(`2000-01-01 ${formValue.break2StartTime}`);
    const break2EndDateTime = new Date(`2000-01-01 ${formValue.break2EndTime}`);
    const break3StartDateTime = new Date(`2000-01-01 ${formValue.break3StartTime}`);
    const break3EndDateTime = new Date(`2000-01-01 ${formValue.break3EndTime}`);
    if (
      (targetDateTime >= break1StartDateTime && targetDateTime <= break1EndDateTime && position !== 1) ||
      (targetDateTime >= break2StartDateTime && targetDateTime <= break2EndDateTime && position !== 2) ||
      (targetDateTime >= break3StartDateTime && targetDateTime <= break3EndDateTime && position !== 3)
    ) {
      return true;
    } else {
      return false;
    }
  }
}


